export default class Interceptor {
  constructor(func = () => { }) {
    this.runFunc = func;
  }

  run = (data, setData) => this.runFunc(data, setData);
}
